import {
  APP_USER_IDAM_ADD_BUSINESS_PROFILE_ROUTE,
  APP_USER_IDAM_REGISTER_ROUTE,
  CHECKOUT_ROUTE, USER_ADD_BUSINESS_ROUTE
} from '~shared/constants';
import { ACCOUNT_AFTER_CHANGE_EMAIL_LINK } from '~shared/constants/links.constants';

export const SIMPLIFIED_HEADER_URLS = [
  ACCOUNT_AFTER_CHANGE_EMAIL_LINK,
  `/${CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}`,
];
